import {
    Bar
} from 'vue-chartjs'
import Chart from 'chart.js'

export default {
    extends: Bar,
    props: {
        labels: {
            type: Array
        },
        uptime: {
            type: Array
        },
        downtime: {
            type: Array
        },
        scheduledDowntime: {
            type: Array
        }
    },
    mounted() {
        Chart.Tooltip.positioners.customPosition = function (unused, position) {
            return {
                x: position.x,
                y: 50
            }
        }

        Chart.defaults.global.legend.onClick = function (event, legendItem) {
            return false
        }

        let that = this
        this.renderChart({
            labels: this.labels,
            datasets: [{
                label: 'No incidents',
                backgroundColor: '#74C080',
                data: this.uptime
            }, {
                label: 'Unscheduled incidents',
                backgroundColor: '#D64242',
                data: this.downtime
            }, {
                label: 'Scheduled incidents',
                backgroundColor: '#408fec',
                data: this.scheduledDowntime
            }]
        }, {
            title: {
                display: false
            },
            tooltips: {
                mode: 'x-axis',
                intersect: false,
                position: 'customPosition',
                callbacks: {
                    label: function (tooltipItems, data) {
                        let response = ''
                        if (tooltipItems.yLabel > 0) {
                            if (data.datasets[tooltipItems.datasetIndex].label !== 'No incidents') {
                                response = data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel / 10 + ' incident'
                                if (tooltipItems.yLabel / 10 > 1) {
                                    response += 's'
                                }
                            }
                        }

                        if (tooltipItems.yLabel === 100 && tooltipItems.datasetIndex === 0) {
                            response = 'No incidents reported.'
                        }

                        return response
                    },
                    title: function (tooltipItems, data) {
                        that.$emit('highlight', tooltipItems[0].xLabel)
                        if (tooltipItems.length === 0) {
                            return 'No data available.'
                        } else {
                            let items = tooltipItems.filter(function (item) {
                                return item.yLabel !== 0
                            })

                            if (items.length > 0) {
                                return items[0].xLabel
                            } else {
                                return 'No data available.'
                            }
                        }
                    }
                }
            },
            legend: {
                display: true,
                position: 'bottom'
            },
            responsive: true,
            maintainAspectRatio: true,
            scales: {
                xAxes: [{
                    showScale: false,
                    stacked: true,
                    gridLines: {
                        display: false,
                        color: 'rgba(0, 0, 0, 0)'
                    }
                }],
                yAxes: [{
                    stacked: true,
                    display: false
                }]
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/IncidentChart.js